import { ReactElement } from "react";
import Grow from "@avinet/adaptive-ui-core/layout/Grow";
import Row from "@avinet/adaptive-ui-core/layout/Row";
import { useTranslate } from "@avinet/adaptive-ui-translate";
import { FormTreeEntry } from "../../../hooks/useFormTree";
import { Icon } from "../../Icon";
import SectionRenderer from "../SectionRenderer";

function WizardPageRenderer({
  entry,
  onPrev,
}: {
  entry: FormTreeEntry;
  onPrev?: () => void;
}): ReactElement {
  const t = useTranslate("Form");
  return (
    <>
      <div className="wizard-page-content">
        {entry.group?.title && <h3>{entry.group.title}</h3>}
        {entry.children.map((section) => {
          return (
            <SectionRenderer key={section.idx} section={section.section} />
          );
        })}
      </div>

      <Row className="btn-group">
        {onPrev && (
          <button type="button" className="btn" onClick={onPrev}>
            <Icon name="chevron" rotate={180} /> {t("prev")}
          </button>
        )}
        <Grow />
        <button type="submit" className="btn">
          {t("next")} <Icon name="chevron" />
        </button>
      </Row>
    </>
  );
}

export default WizardPageRenderer;
